import { Trans } from '@lingui/react/macro'
import { useBizUsers } from '../BizApi'
import { BizUserTable } from '../components/BizUserTable'
import { BizActionButtonCreateUser } from '../components/BizActionButtonCreateUser'

export function BizUsersRoute() {
  const { users } = useBizUsers()

  return (
    <div className="flex flex-col gap-4">
      <div className="card" data-testid="BizUsersRoute">
        <div className="grid max-w-7xl gap-4">
          <h2 className="title-sm">
            <Trans>Business users</Trans>
          </h2>
          <BizActionButtonCreateUser className="justify-self-start" />
          <BizUserTable sortBy="role" users={users} view="full" />
          {users.length > 10 && (
            <BizActionButtonCreateUser className="justify-self-start" />
          )}
        </div>
      </div>
    </div>
  )
}
